var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('div',[_vm._v("When a visitor is about to leave your site.")])])}
var staticRenderFns = []

export { render, staticRenderFns }